import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WsService {
  private subjects: Map<string, Subject<any>> = new Map();
  private sockets: Map<string, WebSocket> = new Map();
  // url = "https://dev.hykrsol.com"

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  connectAlerts(cameraId: string): Subject<any> {
    if (this.subjects.has(cameraId)) return this.subjects.get(cameraId)!;

    const subj = new Subject<any>();
    this.subjects.set(cameraId, subj);

    if (!isPlatformBrowser(this.platformId)) {
      console.warn('WS skipped (SSR mode)');
      return subj;
    }

    const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
    const url = `ws://monitordev.anikinitek.com/ws/alerts/${cameraId}`;
    console.log('Alert ws url', url)
    const ws = new WebSocket(url);

    ws.onopen = () => console.log('WS open', cameraId);
    ws.onmessage = ev => {
      try { subj.next(JSON.parse(ev.data)); } catch (e) { console.error('WS parse', e); }
    };
    ws.onclose = () => {
      console.log('WS close', cameraId);
      subj.complete();
      this.subjects.delete(cameraId);
      this.sockets.delete(cameraId);
      // attempt reconnect after short delay
      setTimeout(() => this.connectAlerts(cameraId), 2000);
    };
    ws.onerror = (e) => console.error('WS error', e);

    this.sockets.set(cameraId, ws);
    return subj;
  }

  disconnectAlerts(cameraId: string) {
    const s = this.sockets.get(cameraId);
    if (s) s.close();
    this.sockets.delete(cameraId);
    const subj = this.subjects.get(cameraId);
    if (subj) subj.complete();
    this.subjects.delete(cameraId);
  }

  connectDetections(cameraId: string): Subject<any> {
    const subj = new Subject<any>();

    if (!isPlatformBrowser(this.platformId)) return subj;

    // const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
    const url = `ws://monitordev.anikinitek.com/ws/detections/${cameraId}`;
    console.log('det ws url')
    const ws = new WebSocket(url);

    ws.onmessage = ev => {
      try {
        subj.next(JSON.parse(ev.data));
      } catch (e) {
        console.error('WS parse error', e);
      }
    };

    ws.onclose = () => {
      subj.complete();
      setTimeout(() => this.connectDetections(cameraId), 2000);
    };

    ws.onerror = e => console.error('WS error', e);

    return subj;
  }



  
  connectFaces(cameraId: string): Subject<any> {
    const subj = new Subject<any>();

    if (!isPlatformBrowser(this.platformId)) return subj;

    const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
    const url = `ws://monitordev.anikinitek.com/ws/faces/${cameraId}`;

    const ws = new WebSocket(url);

    ws.onmessage = ev => {
      try {
        subj.next(JSON.parse(ev.data));
      } catch (e) {
        console.error('Face WS parse error', e);
      }
    };

    ws.onclose = () => {
      subj.complete();
    };

    ws.onerror = e => console.error('Face WS error', e);

    return subj;
  }

}
